import { addPermissionsToRoute } from '@qsrsoft/myq-core';
const routes = {
  name: 'Sales',
  icon: 'mdi-chart-line',
  path: '/reports/sales',
  children: [
    {
      path: '/reports/sales/salesLedger',
      name: 'Sales Ledger',
      meta: { id: 'mc-salesLedger', permission: 'sales' },
      component: () => import('./SalesLedger.vue'),
      ...addPermissionsToRoute(['sales']),
    },
    {
      path: '/reports/sales/salesPointOfOrder',
      name: 'Sales - Point Of Order',
      meta: { id: 'mc-salesPointOfOrder', permission: 'sales' },
      component: () => import('./SalesPointOfOrder.vue'),
      ...addPermissionsToRoute(['sales']),
    },
  ],
};

export default routes;
